
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lpnc/[slug]",
      function () {
        return require("private-next-pages/lpnc/[slug].tsx");
      }
    ]);
  